import React, { memo } from 'react'

export default memo(() => (
  <svg width="1em" height="1em" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M119.024 61.1067L69.9983 43.8652L20.9727 61.1067L69.9983 78.6096L119.024 61.1067Z" fill="#23A4DE" />
    <path d="M119.022 61.1067L69.9961 43.8652V78.6096L119.022 61.1067Z" fill="#0061A8" />
    <path
      d="M88.5528 17.4922H50.3176C46.6078 17.4922 43.5898 20.5716 43.5898 24.3558V106.549C43.5898 110.333 46.6078 113.412 50.3176 113.412H88.5528C92.2626 113.412 95.2814 110.333 95.2814 106.549V24.3558C95.2814 20.5716 92.2626 17.4922 88.5528 17.4922V17.4922Z"
      fill="#262F69"
    />
    <path
      d="M88.529 21.4658H82.8467C82.3106 21.4658 81.8764 21.9086 81.8764 22.4547C81.8764 23.7663 80.8249 24.839 79.5399 24.839H59.2847C57.9988 24.839 56.9473 23.7663 56.9473 22.4547C56.9473 21.9086 56.5132 21.4658 55.977 21.4658H50.2947C48.7295 21.4658 47.4609 22.7599 47.4609 24.3556V89.2042H91.3628V24.3556C91.3628 22.7599 90.0942 21.4658 88.529 21.4658Z"
      fill="white"
    />
    <path d="M50.8828 54.0697L69.4588 35.8542L88.0348 54.0697V79.2243H50.8828V54.0697Z" fill="#262F69" />
    <path d="M50.8828 54.0697L69.4588 35.8542L88.0348 54.0697V68.3818L50.8828 54.0697Z" fill="#7BC9EB" />
    <path d="M88.036 79.2243H77.1623L61.7578 43.407L69.46 35.8542L88.036 54.0697V79.2243Z" fill="#0061A8" />
    <path d="M88.036 54.0697V68.3818L69.46 61.3156L61.7578 43.407L69.46 35.8542L88.036 54.0697Z" fill="#32BCFA" />
    <path d="M69.9983 78.6575L20.9727 61.1064V124.223L69.9983 140V78.6575Z" fill="#31448F" />
    <path d="M119.022 124.223V61.1064L69.9961 78.6575V140L119.022 124.223Z" fill="#262F69" />
    <path d="M20.9715 61.1074L4 79.4841L53.9483 97.9011L69.9972 78.6103L20.9715 61.1074Z" fill="#7BC9EB" />
    <path d="M119.022 61.1064L135.999 78.4831L86.0506 96.9002L69.9961 78.6093L119.022 61.1064Z" fill="#23A4DE" />
    <rect
      width="17.8142"
      height="17.8731"
      rx="4"
      transform="matrix(0.763205 -0.646157 0.632487 0.774571 77.7969 52.2031)"
      fill="#FFE5C7"
    />
    <rect
      width="33.4161"
      height="33.6394"
      rx="6"
      transform="matrix(0.850452 0.526053 -0.51502 0.857178 34.8359 8)"
      fill="#FFB71B"
    />
    <rect
      width="13.4768"
      height="13.6369"
      rx="3"
      transform="matrix(0.950509 0.310697 -0.30262 0.953111 102.711 9.05469)"
      fill="#FFE5C7"
    />
  </svg>
))
